<template>
  <queues-template />
</template>

<script>
import QueuesTemplate from "@/app/queues/components/templates/QueuesTemplate.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    QueuesTemplate,
  },
});
</script>
